export function mask_only_number(v: string) {
  v = v.replace(/[^\d\s-/]/g, "");
  return v;
}
